import { render, staticRenderFns } from "./TrialPhaseInfoCard.vue?vue&type=template&id=13e5dec2"
import script from "./TrialPhaseInfoCard.vue?vue&type=script&lang=js"
export * from "./TrialPhaseInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports